export interface PaletteEntry {
  name: string;
  utility: string;
  hexLight: string;
  hexDark: string;
}

export const SURFACES: PaletteEntry[] = [
  {
    name: "page",
    utility: "bg-page",
    hexLight: "oklch(1 0 0)",
    hexDark: "oklch(0.145 0 0)",
  },
  {
    name: "surface",
    utility: "bg-surface",
    hexLight: "oklch(0.97 0 0)",
    hexDark: "oklch(0.269 0 0)",
  },
  {
    name: "hairline",
    utility: "border-hairline",
    hexLight: "oklch(0.922 0 0)",
    hexDark: "oklch(1 0 0 / 10%)",
  },
];

export const TEXT: PaletteEntry[] = [
  {
    name: "ink-body",
    utility: "text-ink-body",
    hexLight: "oklch(0.145 0 0)",
    hexDark: "oklch(0.985 0 0)",
  },
  {
    name: "ink-display",
    utility: "text-ink-display",
    hexLight: "oklch(0.145 0 0)",
    hexDark: "oklch(0.985 0 0)",
  },
  {
    name: "ink-muted",
    utility: "text-ink-muted",
    hexLight: "oklch(0.556 0 0)",
    hexDark: "oklch(0.708 0 0)",
  },
];

export const SPLASH: PaletteEntry[] = [
  {
    name: "primary",
    utility: "bg-primary / text-primary",
    hexLight: "oklch(0.205 0 0)",
    hexDark: "oklch(0.922 0 0)",
  },
  {
    name: "primary foreground",
    utility: "text-primary-foreground",
    hexLight: "oklch(0.985 0 0)",
    hexDark: "oklch(0.205 0 0)",
  },
  {
    name: "secondary",
    utility: "bg-secondary / text-secondary-foreground",
    hexLight: "oklch(0.97 0 0)",
    hexDark: "oklch(0.269 0 0)",
  },
  {
    name: "accent",
    utility: "bg-accent / text-accent-foreground",
    hexLight: "oklch(0.97 0 0)",
    hexDark: "oklch(0.269 0 0)",
  },
  {
    name: "ring",
    utility: "ring-ring",
    hexLight: "oklch(0.708 0 0)",
    hexDark: "oklch(0.556 0 0)",
  },
  {
    name: "destructive",
    utility: "bg-destructive / text-destructive",
    hexLight: "oklch(0.577 0.245 27.325)",
    hexDark: "oklch(0.704 0.191 22.216)",
  },
];

export const FONTS = {
  display: "Geist Variable",
  body: "Geist Variable",
};
